import type { FollowListType } from '~/app/(default-layout)/user/[userId]/_containers/follows-container/types';
import { css } from '@styled-system/css';
import { Divider, Box, HStack, styled } from '@styled-system/jsx';

type Props = {
  followListType: FollowListType;
  onClick: (type: FollowListType) => void;
};

export const TabsContainer = ({ followListType, onClick }: Props) => {
  return (
    <Box flexDir="row" alignItems="flex-start" w="100%">
      <HStack
        w="100%"
        display="flex"
        flexDir="row"
        marginTop="4px"
        alignItems="center"
        gap="8px"
        borderBottomColor="#E2E8F0"
        borderBottomWidth="1px"
        height={{
          base: '32px',
          lg: 'auto',
        }}
      >
        <Box
          key="followers"
          onClick={() => onClick('follower')}
          className={css({
            padding: '15px',
            position: 'relative',
            cursor: 'pointer',
            width: '100%',
            textAlign: 'center',
          })}
        >
          <styled.h2
            fontSize="size_13"
            fontWeight={followListType === 'follower' ? '600' : 'auto'}
          >
            フォロワー
          </styled.h2>
          {followListType === 'follower' && (
            <Divider
              position="absolute"
              bottom={{ base: '8px', lg: '0' }}
              left="0"
              right="0"
              color="content_primary"
              thickness="3px"
            />
          )}
        </Box>
        <Box
          key="followees"
          onClick={() => onClick('followee')}
          className={css({
            padding: '15px',
            position: 'relative',
            cursor: 'pointer',
            width: '100%',
            textAlign: 'center',
          })}
        >
          <styled.h2
            fontSize="size_13"
            fontWeight={followListType === 'followee' ? '600' : 'auto'}
          >
            フォロー中
          </styled.h2>
          {followListType === 'followee' && (
            <Divider
              position="absolute"
              bottom={{ base: '8px', lg: '0' }}
              left="0"
              right="0"
              color="content_primary"
              thickness="3px"
            />
          )}
        </Box>
      </HStack>
    </Box>
  );
};
